import { useTranslations } from 'next-intl';
import { ReactNode, useState } from 'react';

export default function Confirmation({
  onConfirm,
  title,
  className = '',
  children,
}: {
  onConfirm: any;
  title?: string;
  className?: string;
  children: ReactNode;
}) {
  const t = useTranslations('general');
  const [confirm, setConfirm] = useState(false);
  const confirmationHandler = () => {
    if (confirm) {
      setConfirm(false);
      onConfirm();
    }
    if (!confirm) {
      setConfirm(true);
      setTimeout(() => {
        setConfirm(false);
      }, 3000);
    }
  };
  return (
    <button
      onClick={confirmationHandler}
      className={`${className} relative`}
      title={title}
      type='button'
    >
      {confirm && (
        <span className='absolute bottom-0 right-full top-0 flex translate-x-2 items-center rounded-bl-md rounded-tl-md bg-inherit px-4 font-roboto-condensed text-sm font-semibold'>
          {t('confirm')}
        </span>
      )}
      {children}
    </button>
  );
}
